/**
 * @author Jorge Casas
 * @creationDate 22/07/2024
 */

/**
 * This function formats a number to a string with a comma as a thousand separator
 *
 * @param {Number} quantity
 * @returns {String}
 * @returns {String} Returns the formatted quantity
 * @throws {Error} The quantity is not a valid integer number
 */
export const formatQuantity = (quantity) => {
  try {
    if (typeof quantity === 'number' && Number.isInteger(quantity) && !isNaN(quantity)) {
      return quantity.toLocaleString('es-MX');
    } else {
      console.log('La cantidad no es un número entero válido');
      return '';
    }
  } catch (error) {
    console.log('🚀 ~ file: format-quantity.js:23 ~ formatQuantity ~ error:', error);
    return '';
  }
};



// WEBPACK FOOTER //
// src/utils/additional-functions/format-quantity.js